import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import paymentModesReducer from "./slices/paymentModesSlice";
import transactionReducer from "./slices/transactionSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    transaction: transactionReducer,
    common: require("./slices/commonApiSlice").default,
    shop: require("./slices/shopsSlice").default,
    banner: require("./slices/bannersSlice").default,
    categories: require("./slices/categoriesSlice").default,
    subCategories: require("./slices/subCategoriesSlice").default,
    categoryServices: require("./slices/categoryServicesSlice").default,
    states: require("./slices/statesSlice").default,
    districts: require("./slices/districtsSlice").default,
    talukas: require("./slices/talukasSlice").default,
    subscriptionPackages: require("./slices/subscriptionPackagesSlice").default,
    paymentModes: paymentModesReducer,
    companyDetails: require("./slices/companyDetailsSlice").default,
    utility: require("./slices/utilitySlice").default,
    businessOwner: require("./slices/businessOwnerSlice").default,
    customers: require("./slices/customersSlice").default,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"],
      },
    }),
});

export default store;
